const messages = {
  required: (field) => `Обязательное поле`,
  min_value: (field) => `Не допустимое минимальное значение`,
  max_value: (field) => `Не допустимое максимальное значение`,
  digits: (field, [length]) => `Поле ${field} должно быть числовым и точно содержать ${length} цифры.`,
  selected: (field) => `Необходимо выбрать значение`,
  competence_with_levels: (field) => `Отсутствуют КОДы по данной профессии/специальности (ДЭ)`,
  max: () => 'Превышено максимальное количество символов'
}

const locale = {
  name: 'ru',
  messages,
  attributes: {}
}

export default locale
